module.exports = __webpack_public_path__ + "static/img/GoldenMahjong2-zh.28506237.png";